import { render, staticRenderFns } from "./sponsor_tree.vue?vue&type=template&id=7f2c7042&"
import script from "./sponsor_tree.vue?vue&type=script&lang=js&"
export * from "./sponsor_tree.vue?vue&type=script&lang=js&"
import style0 from "./sponsor_tree.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports